import { useDeviceType } from "@dash/mq";
import { Page, PageHeader } from "@dash/page";
import { QuerySkeleton } from "@dash/skeleton";
import { useToast } from "@dash/toast";
import { useContext, useState } from "react";

import { IamAuthContext } from "@megaron/auth-react";
import { DocType } from "@megaron/docs-contracts";
import { useClientManager } from "@megaron/react-clients";

import { DocsMobileList } from "./IndexersMobileList";
import { IndexersTable } from "./IndexersTable";

export const DocsPage = () => {
  const { isMobile } = useDeviceType();

  const toast = useToast();

  const auth = useContext(IamAuthContext);

  const indexersQuery = useClientManager("docs").indexersQuery().useQuery({}, { enabled: !!auth.iamUser });

  const refreshMutation = useClientManager("docs").refreshIndexDocs().useMutation();

  const [refreshingDoctype, setRefreshingDoctype] = useState<DocType | null>(null);

  const handleRefresh = (module: DocType) => {
    setRefreshingDoctype(module);

    refreshMutation.mutate(
      { module },
      {
        onSuccess: () => {
          indexersQuery.refetch();
          setRefreshingDoctype(null);
        },
        onError: () => {
          toast.error("Failed to refresh index");
          setRefreshingDoctype(null);
        },
      },
    );
  };

  return (
    <Page css={{ maxWidth: "100%", marginTop: "2rem" }}>
      <PageHeader>Docs indices</PageHeader>
      <QuerySkeleton query={indexersQuery}>
        {(entries) =>
          isMobile ? (
            <DocsMobileList
              indexers={entries}
              onRefresh={handleRefresh}
              isLoading={indexersQuery.isFetching}
              isRefreshing={refreshMutation?.isLoading}
            />
          ) : (
            <IndexersTable
              indexers={entries}
              onRefresh={handleRefresh}
              isLoading={indexersQuery.isFetching}
              isRefreshing={refreshMutation?.isLoading}
              refreshingDoctype={refreshingDoctype}
            />
          )
        }
      </QuerySkeleton>
    </Page>
  );
};
